<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TopoRender',
})
</script>
<template>
    <div class="topo-render" :style="layerStyle" v-if="configData.layer">
        <template >
            <div class="topo-render-wrapper"
                    v-for="(component,index) in configData.components"
                    :key="index"
                    @click="doClickComponent(component)"
                    @dblclick="doDbClickComponent(component)"
                    :class="{'topo-render-wrapper-clickable': component.action.length > 0 }"
                    v-show="component.style.visible == undefined? true:component.style.visible"
                    :style="{
                        left: component.style.position.x + 'px',
                        top: component.style.position.y + 'px',
                        width: component.style.position.w + 'px',
                        height: component.style.position.h + 'px',
                        backgroundColor: component.style.backColor,
                        zIndex: component.style.zIndex,
                        borderWidth: component.style.borderWidth + 'px',
                        borderStyle: component.style.borderStyle,
                        borderColor: component.style.borderColor,
                        transform: component.style.transform? `rotate(${component.style.transform}deg)`:'rotate(0deg)',
                    }">
                <component v-bind:is="parseView(component)" :detail="component" ref="spirit" />
            </div>
        </template>
    </div>
</template>

<script setup lang="ts" name="TopoRender">


import topoUtil from './util/topo-util';
import {ref,computed, onMounted} from 'vue'
const spirit=ref()
const configData=ref<Object>(null);
onMounted(()=>{
        var temp = localStorage.getItem('topoData');
        configData.value = JSON.parse(temp);

})
const layerStyle=computed(()=> {
            var styles = [];
            if(this.configData.layer.backColor) {
                styles.push(`background-color: ${this.configData.layer.backColor}`);
            }
            if(this.configData.layer.backgroundImage) {
                styles.push(`background-image: url("${this.configData.layer.backgroundImage}")`);
            }
            if(this.configData.layer.width > 0) {
                styles.push(`width: ${this.configData.layer.width}px`);
            }
            if(this.configData.layer.height > 0) {
                styles.push(`height: ${this.configData.layer.height}px`);
            }
            var style = styles.join(';');
            return style;
        })
function parseView(ct) {
            return topoUtil.parseViewName(ct);
        }
function doClickComponent(ct){
            for(var i = 0; i < ct.action.length; i++) {
                var action = ct.action[i];
                if(action.type == 'click') {
                     handleComponentActuib(action);
                }
            }
        }
function doDbClickComponent(component){
            for(var i = 0; i < component.action.length; i++) {
                var action = component.action[i];
                if(action.type == 'dblclick') {
                     handleComponentActuib(action);
                }
            }
        }
function handleComponentActuib(action){
            if(action.action == 'visible'){
                if(action.showItems.length > 0) {
                    action.showItems.forEach(identifier => {
                        showComponent(identifier,true);
                    });
                }
                if(action.hideItems.length > 0) {
                    action.hideItems.forEach(identifier => {
                        showComponent(identifier,false);
                    });
                }
            } else if(action.action == 'service') {
                sendFun(action);
            }
        }
function showComponent(identifier,visible) {
            console.log('show:' + identifier + ',visible:' + visible);
            var spirits =spirit.value;
            for(var i = 0; i < spirits.length; i++){
                var spirit = spirits[i];
                if(spirit.detail.identifier == identifier) {
                    spirit.detail.style.visible = visible;
                    break;
                }
            }
        }
</script>

<style lang="scss">
    .topo-render {
        overflow: auto;
        background-color: white;
        background-clip: padding-box;
        background-origin: padding-box;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;
        height: 100%;

        .topo-render-wrapper {
            position: absolute;
        }

        .topo-render-wrapper-clickable {
            cursor: pointer;
        }
    }
</style>
